import { FaFacebook, FaYoutube, FaInstagram } from 'react-icons/fa';
import { FaSquareWhatsapp } from 'react-icons/fa6';
import { SOCIAL_MEDIA_LINKS } from '../components/core/constants';

// Contact Information
export const PHONE_NUMBER = '+1 (479) 640-5446';
export const PHONE_LINK = 'tel:+14796405446';
export const CONTACT_QR_CODE_PATH = require('../assets/qr-codes/contact-card.png');

// Social Media Links Configuration
export const SOCIAL_LINKS_CONFIG = [
  {
    href: SOCIAL_MEDIA_LINKS.whatsapp,
    colorScheme: 'green',
    color: 'green.600',
    hoverBg: 'green.50',
    ariaLabel: 'Contact at Whatsapp',
    icon: <FaSquareWhatsapp />
  },
  {
    href: SOCIAL_MEDIA_LINKS.instagram,
    colorScheme: 'pink',
    color: 'pink.600',
    hoverBg: 'pink.50',
    ariaLabel: 'Follow on Instagram',
    icon: <FaInstagram />
  },
  {
    href: SOCIAL_MEDIA_LINKS.youtube,
    colorScheme: 'red',
    color: 'red.600',
    hoverBg: 'red.50',
    ariaLabel: 'Subscribe on YouTube',
    icon: <FaYoutube />
  },
  {
    href: SOCIAL_MEDIA_LINKS.facebook,
    colorScheme: 'blue',
    color: 'blue.600',
    hoverBg: 'blue.50',
    ariaLabel: 'Follow on Facebook',
    icon: <FaFacebook />
  }
];

// QR Codes Configuration
export const SOCIAL_QR_CODES = [
  {
    key: 'website',
    label: 'Website',
    img: require('../assets/qr-codes/website.png'),
  },
  {
    key: 'whatsapp',
    label: 'WhatsApp Business',
    img: require('../assets/qr-codes/whatsapp.png'),
  },
  {
    key: 'instagram',
    label: 'Instagram',
    img: require('../assets/qr-codes/instagram.png'),
  },
  {
    key: 'youtube',
    label: 'YouTube',
    img: require('../assets/qr-codes/youtube.png'),
  },
  {
    key: 'facebook',
    label: 'Facebook',
    img: require('../assets/qr-codes/facebook.png'),
  },
];
